import { WbScroller } from '../../webit_modules/vendor/webit_interactive/wb-scroller/src';

export class WbAnimations {
  constructor() {
    this.addDynamicEffects();
    this.addScroller();
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.addAnims();
      resolve();
    });
  }

  addDynamicEffects() {
    const corpo = document.querySelector('.wb-corpo.is-animated');
    const texts = corpo?.querySelectorAll(
      'h1, h2, h3:not(.accordion__title, .publications-list-item__title, .wb-member-mosaic__name), h4, h5, h6, p, li, .wb-button, .wb-surtitle'
    );

    const images = corpo?.querySelectorAll('.w-image, img, i');
    const forms = corpo?.querySelectorAll('form,form > *');

    corpo?.querySelectorAll(':scope > *')?.forEach((ele) => ele.setAttribute('data-scroll-section', ''));
    images?.forEach((ele) => ele.setAttribute('data-scroll-effect', 'fadeIn'));
    texts?.forEach((ele) => ele.setAttribute('data-scroll-effect', 'fadeInUp'));
  }

  addScroller() {
    this.scroller = window.WbScroller = new WbScroller();
    this.scroller.init();
  }

  wait(duration = 25) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, duration);
    });
  }

  addAnims() {
    this.addCorpoAnims();
  }

  addCorpoAnims() {
    const corpo = document.querySelector('.wb-corpo');

    this.scroller.addAnim({
      element: corpo?.querySelectorAll('.wb-media-text__bg-title'),
      trigger: '[data-scroll-section]',
      timeline: [{ effect: 'fadeInUp', to: { stagger: 0.1, opacity: 0.25 } }],
      batch: true,
    });

    corpo?.querySelectorAll('.wb-statistics__value')?.forEach((stats) => {
      this.scroller.addAnim({
        element: stats,
        trigger: '[data-scroll-section]',
        timeline: [
          {
            to: {
              innerText: stats.dataset.number,
              stagger: 0.1,
              snap: {
                innerText: 1,
              },
              duration: 3,
            },
          },
        ],
      });
    });
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.WbAnimations = new WbAnimations();
  }
});
